import React from 'react';
import { Reveal } from './Reveal';
import { stats } from '../data/stats';
export function StatsBar() {
  return <section aria-label="Key figures" className="border-y border-brand-dark bg-brand-alt py-8 md:py-10" data-id="element-161" data-mp="1tbjghngupucr">
      <Reveal className="mx-auto grid max-w-[1120px] grid-cols-2 gap-y-7 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-162" data-mp="1oa3v1uarhltu">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-dark' : ''}`} data-id="element-163" data-mp="1ecz99vktvsdk" data-mpi={index}>
            <span className="mb-1 font-serif text-3xl font-black text-brand-blue md:text-4xl" data-id="element-164" data-mp="19ko52gj21kf7">{value}</span>
            <span className="max-w-[10rem] text-[10px] font-bold uppercase leading-tight tracking-[0.1em] text-brand-gray md:text-xs" data-id="element-165" data-mp="10lt1lc7eaofl">
              {label}
            </span>
          </div>)}
      </Reveal>
    </section>;
}